import api from '.';

const pricesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createChargePointPrice: builder.mutation({
      query: ({ id, data }) => ({
        url: `/charge-points/${id}/prices`,
        method: 'POST',
        body: data
      }),
      transformResponse(res) {
        return res;
      }
    }),

    updateChargePointPrice: builder.mutation({
      query: ({ id, data, where }) => ({
        url: `/charge-points/${id}/prices?where=${JSON.stringify(where)}`,
        method: 'PATCH',
        body: data
      })
    })
  })
});

export default pricesApi;
export const { useCreateChargePointPriceMutation, useUpdateChargePointPriceMutation } = pricesApi;
